<template>
<div>


  <div class="vx-row mt-2 mb-4 ml-0">
<!--    <vs-button @click="onClickGoBack"  button="submit" color="warning" type="border" size="small" class="mt-2 mb-8 float-left">Go Back to Raw Materials</vs-button>-->

    <vs-breadcrumb class="ml-0">
      <li><router-link to="/pages/manage-nimble/suppliers">Manage Suppliers</router-link><span class="vs-breadcrum--separator">/</span></li>
      <li><router-link :to="`/pages/manage-nimble/suppliers/${rawMaterialDetails.supplier.id}`">{{rawMaterialDetails.supplier.company_name}}</router-link><span class="vs-breadcrum--separator">/</span></li>
      <li><router-link :to="`/pages/manage-nimble/suppliers/${rawMaterialDetails.supplier.id}?step=3`">Raw Materials</router-link><span class="vs-breadcrum--separator">/</span></li>
      <li :active="true" aria-current="page" class="text-success">
        {{rawMaterialDetails.company_product_code ?
        rawMaterialDetails.category.prefix + '-' +rawMaterialDetails.company_product_code : rawMaterialDetails.supplier_product_name}}
      </li>
    </vs-breadcrumb>
    <!--     <vs-button v-if="siteData.is_approved !== 2" @click="openApprovalConfirm" button="submit" class="ml-auto mt-2 mb-8 float-right">Approve Site</vs-button>-->
    <!--     <vs-button v-if="siteData.is_approved === 2" @click="openNotApprovalConfirm" button="submit" class="ml-auto mt-2 mb-8 float-right" color="danger">Not Approve Site</vs-button>-->
<!--    <vs-switch class="float-right ml-auto">-->
<!--      <span slot="on">Approve Site</span>-->
<!--      <span slot="off">Not Approve Site</span>-->
<!--    </vs-switch>-->
  </div>
  <div class="vx-row mt-2 mb-4 ml-0">
    <div class="float-right mr-4">
      <vs-chip style="border-radius: 5px" class="mr-2" transparent v-if="status.status" :color="statusColorFactory(status.status ? status.status.id : '')">
        STATUS: {{status.status ? status.status.name : ''}}
      </vs-chip>
      <vs-chip class="float-right mb-8" transparent color="dark">
        STAGE: {{ isProduction === true ? "PRODUCTION" : "DEVELOPMENT" }}
      </vs-chip>
    </div>

    <div class="float-right ml-auto mr-4">
      <div class="ml-auto mr-2">
        <v-select class="stageSelect" :clearable="false" v-model="isProduction" @input="onChangeStageConfirm" :options="stageOptions" :reduce="option => option.key" placeholder="change stage" label="value" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
      </div>

    </div>

    <div class="float-right mr-0">
      <vs-button v-if="[1, 2].includes(status.status.id) && !rawMaterialDetails.company_product_code" @click="openApprovalConfirm" class="float-right ml-2 mr-0" type="border" color="primary">Approve Raw Material</vs-button>
      <vs-button v-if="[1, 2].includes(status.status.id) && rawMaterialDetails.company_product_code" @click="openApprovalDirectConfirm" class="float-right ml-2 mr-0" type="border" color="primary">Approve Raw Material</vs-button>
      <vs-button v-if="[1, 2].includes(status.status.id)" @click="openRejectConfirm" class="float-right ml-2 mr-0" type="border" color="danger">Reject Raw Material</vs-button>
      <vs-button v-if="status.status.id ===5 ||  status.status.id === 6 || status.status.id === 7" @click="openReInstateConfirm" class="float-right ml-2 mr-0" type="border" color="success">Re-Instate Raw Material</vs-button>

    </div>
    <div class=" float-right ml-4"  v-if="status.status.id === 3 || status.status.id ===5 ||  status.status.id === 6 || status.status.id === 7">
      <div class="dropdown-button-container">
        <vs-button color="danger" class="btnx" type="filled">Suspend Raw Material</vs-button>
        <vs-dropdown>
          <vs-button color="danger" class="btn-drop" type="filled" icon="expand_more"></vs-button>
          <vs-dropdown-menu>
            <vs-dropdown-item v-if="status.status.id !== 5" @click="onClickSuspendLevel(1)"> Suspend Level 1 </vs-dropdown-item>
            <vs-dropdown-item v-if="status.status.id !== 6" @click="onClickSuspendLevel(2)"> Suspend Level 2 </vs-dropdown-item>
            <vs-dropdown-item v-if="status.status.id !== 7" @click="onClickSuspendLevel(3)"> Suspend Level 3 </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>
  </div>

  <div class="vx-row">
    <vs-tabs v-model="activeTab" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">
      <!-- GENERAL -->
      <vs-tab :disabled="false" icon-pack="feather" icon="icon-box"
              :label="!isSmallerScreen ? `General ${isCompleted('is_raw_material_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-manufacturing-home :isCompleted="markCompletedList.is_raw_material_marked_completed"
                                       :isProduction="isProduction"
                                       v-on:notify="notify($event)"
                                       v-on:mark-as-complete="markAsComplete($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-user-check"
              :label="!isSmallerScreen ? `RM Product Identity ${isCompleted('is_raw_material_product_identity_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-manufacturing-employee v-on:notify="notify($event)"
                                           :isProduction="isProduction"
                                           v-on:mark-as-complete="markAsComplete($event)"
                                           :isCompleted="markCompletedList.is_raw_material_product_identity_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-grid"
              :label="!isSmallerScreen ? `P, C, S parameters ${isCompleted('is_raw_material_p_c_s_parameter_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-manufacturing-site-details v-on:notify="notify($event)"
                                               :isProduction="isProduction"
                                               v-on:mark-as-complete="markAsComplete($event)"
                                               :isCompleted="markCompletedList.is_raw_material_p_c_s_parameter_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-star"
              :label="!isSmallerScreen ? `Manufacturing Process ${isCompleted('is_raw_material_manufacturing_process_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-manufacturing-process v-on:notify="notify($event)"
                                                       :isProduction="isProduction"
                                                       v-on:mark-as-complete="markAsComplete($event)"
                                                       :isCompleted="markCompletedList.is_raw_material_manufacturing_process_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-check"
              :label="!isSmallerScreen ? `Product Authenticity ${isCompleted('is_raw_material_product_authenticity_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-product-authenticity v-on:notify="notify($event)"
                                                      :isProduction="isProduction"
                                                      v-on:mark-as-complete="markAsComplete($event)"
                                                      :isCompleted="markCompletedList.is_raw_material_product_authenticity_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-shield-off"
              :label="!isSmallerScreen ? `Composition ${isCompleted('is_raw_material_composition_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-composition v-on:notify="notify($event)"
                                             :isProduction="isProduction"
                                             v-on:mark-as-complete="markAsComplete($event)"
                                             :isCompleted="markCompletedList.is_raw_material_composition_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-box"
              :label="!isSmallerScreen ? `Additives Preservatives ${isCompleted('is_raw_material_additives_preservative_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-additives-preservatives v-on:notify="notify($event)"
                                                         :isProduction="isProduction"
                                                         v-on:mark-as-complete="markAsComplete($event)"
                                                         :isCompleted="markCompletedList.is_raw_material_additives_preservative_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-circle"
              :label="!isSmallerScreen ? `Solvents ${isCompleted('is_raw_material_solvent_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-solvents v-on:notify="notify($event)"
                                          v-on:mark-as-complete="markAsComplete($event)"
                                          :isProduction="isProduction"
                                          :isCompleted="markCompletedList.is_raw_material_solvent_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-triangle"
              :label="!isSmallerScreen ? `Enzymes & Catalysts ${isCompleted('is_raw_material_enzymes_catalyst_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-enzymes-catalysts v-on:notify="notify($event)"
                                                   v-on:mark-as-complete="markAsComplete($event)"
                                                   :isProduction="isProduction"
                                                   :isCompleted="markCompletedList.is_raw_material_enzymes_catalyst_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-package"
              :label="!isSmallerScreen ? `Genetically Modified Organisms ${isCompleted('is_raw_material_GMO_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-genetically-modified-organisms v-on:notify="notify($event)"
                                                                v-on:mark-as-complete="markAsComplete($event)"
                                                                :isProduction="isProduction"
                                                                :isCompleted="markCompletedList.is_raw_material_GMO_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-circle"
              :label="!isSmallerScreen ? `Allergens ${isCompleted('is_raw_material_allergen_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-allergens v-on:notify="notify($event)"
                                           v-on:mark-as-complete="markAsComplete($event)"
                                           :isProduction="isProduction"
                                           :isCompleted="markCompletedList.is_raw_material_allergen_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-box"
              :label="!isSmallerScreen ? `Biologically Active Principles ${isCompleted('is_raw_material_BAP_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-biologically-active-principles v-on:notify="notify($event)"
                                                                v-on:mark-as-complete="markAsComplete($event)"
                                                                :isProduction="isProduction"
                                                                :isCompleted="markCompletedList.is_raw_material_BAP_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-triangle"
              :label="!isSmallerScreen ? `Palm Oil and Derivatives ${isCompleted('is_raw_material_palm_oil_derivative_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-palm-oil-derivatives v-on:notify="notify($event)"
                                                      v-on:mark-as-complete="markAsComplete($event)"
                                                      :isProduction="isProduction"
                                                      :isCompleted="markCompletedList.is_raw_material_palm_oil_derivative_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-package"
              :label="!isSmallerScreen ? `Additional information ${isCompleted('is_raw_material_additional_information_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-additional-information v-on:notify="notify($event)"
                                                        v-on:mark-as-complete="markAsComplete($event)"
                                                        :isProduction="isProduction"
                                                        :isCompleted="markCompletedList.is_raw_material_additional_information_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-star"
              :label="!isSmallerScreen ? `Storage & shelf-life ${isCompleted('is_raw_material_storage_shelf_life_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-storage-shelf-life v-on:notify="notify($event)"
                                                    v-on:mark-as-complete="markAsComplete($event)"
                                                    :isProduction="isProduction"
                                                    :isCompleted="markCompletedList.is_raw_material_storage_shelf_life_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-circle"
              :label="!isSmallerScreen ? `Packaging & Transport ${isCompleted('is_raw_material_packaging_transport_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-packaging-transport v-on:notify="notify($event)"
                                                     v-on:mark-as-complete="markAsComplete($event)"
                                                     :isProduction="isProduction"
                                                     :isCompleted="markCompletedList.is_raw_material_packaging_transport_marked_completed"/>
        </div>
      </vs-tab>


      <vs-tab icon-pack="feather" icon="icon-check"
              :label="!isSmallerScreen ? `Dietary Suitability ${isCompleted('is_raw_material_dietary_suitability_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-dietary-suitability v-on:notify="notify($event)"
                                                     v-on:mark-as-complete="markAsComplete($event)"
                                                     :isProduction="isProduction"
                                                     :isCompleted="markCompletedList.is_raw_material_dietary_suitability_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-check-square"
              :label="!isSmallerScreen ? `Contaminants and Pesticides ${isCompleted('is_raw_material_contaminant_pesticide_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-contaminants-pesticides v-on:notify="notify($event)"
                                                         v-on:mark-as-complete="markAsComplete($event)"
                                                         :isProduction="isProduction"
                                                         :isCompleted="markCompletedList.is_raw_material_contaminant_pesticide_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-circle"
              :label="!isSmallerScreen ? `Product Treatments ${isCompleted('is_raw_material_product_treatment_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-product-treatments v-on:notify="notify($event)"
                                                    v-on:mark-as-complete="markAsComplete($event)"
                                                    :isProduction="isProduction"
                                                    :isCompleted="markCompletedList.is_raw_material_product_treatment_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-star"
              :label="!isSmallerScreen ? `Legislative Status ${isCompleted('is_raw_material_legislative_status_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-legislative-status v-on:notify="notify($event)"
                                                    v-on:mark-as-complete="markAsComplete($event)"
                                                    :isProduction="isProduction"
                                                    :isCompleted="markCompletedList.is_raw_material_legislative_status_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-box"
              :label="!isSmallerScreen ? `Global Suitability ${isCompleted('is_raw_material_global_suitability_marked_completed') ? '(completed)' : ''}` : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-global-suitability  v-on:notify="notify($event)"
                                                     v-on:mark-as-complete="markAsComplete($event)"
                                                     :isProduction="isProduction"
                                                     :isCompleted="markCompletedList.is_raw_material_global_suitability_marked_completed"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-circle" :label="!isSmallerScreen ? 'Supporting Documentation' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-supporting-documentation v-on:firstPage="firstPage($event)" v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-triangle" :label="!isSmallerScreen ? 'Commercial Details' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-commercial-details v-on:firstPage="firstPage($event)" v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-power" :label="!isSmallerScreen ? 'ITS Spec' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <supplier-raw-material-company-data v-on:firstPage="firstPage($event)" v-on:notify="notify($event)"/>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-paperclip" :label="!isSmallerScreen ? 'FG Allocations' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <SupplierRawMaterialFgAllocation v-on:firstPage="firstPage($event)" v-on:notify="notify($event)" :rm_code="rawMaterialDetails.code || rawMaterialDetails.supplier_product_name"/>
        </div>
      </vs-tab>
<!--      <vs-tab icon-pack="feather" icon="icon-sliders" :label="!isSmallerScreen ? 'Stocks' : ''">-->
<!--        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">-->
<!--          <supplier-raw-material-stocks v-on:firstPage="firstPage($event)" v-on:notify="notify($event)"/>-->
<!--        </div>-->
<!--      </vs-tab>-->

    </vs-tabs>
  </div>
  <approve-raw-material-pop-up ref="approveRawMaterialPopUp"/>
</div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import vSelect from "vue-select";
  const SupplierRepository = RepositoryFactory.get('supplier');
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

  import ApproveRawMaterialPopUp from '@/components/popups/raw-materials/ApproveRawMaterialPopUp'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  import SupplierManufacturingHome from './SupplierManufacturingHome.vue'
  import SupplierManufacturingEmployee from './SupplierManufacturingEmployee.vue'
  import SupplierManufacturingSiteDetails from './SupplierManufacturingSiteDetails.vue'
  import SupplierManufacturingQuality from './SupplierManufacturingQuility.vue'
  import SupplierManufacturingEnvironment from './SupplierManufacturingEnvironment.vue'
  import SupplierManufacturingEthical from './SupplierManufacturingEthical.vue'
  import SupplierManufacturingAllergens from './SupplierManufacturingAllergens.vue'
  import SupplierManufacturingHaccp from './SupplierManufacturingHaccp.vue'
  import SupplierManufacturingPest from './SupplierManufacturingPest.vue'
  import SupplierManufacturingTransport from './SupplierManufacturingTransport.vue'
  import SupplierManufacturingHealthSafety from './SupplierManufacturingHealthSafety.vue'
  import SupplierManufacturingAuthenticity from './SupplierManufacturingAuthenticity.vue'
  import SupplierManufacturingHygiene from './SupplierManufacturingHygiene.vue'
  import SupplierRawMaterialManufacturingProcess from './SupplierRawMaterialManufacturingProcess.vue'
  import SupplierRawMaterialProductAuthenticity from './SupplierRawMaterialProductAuthenticity.vue'
  import SupplierRawMaterialComposition from './SupplierRawMaterialComposition.vue'
  import SupplierRawMaterialAdditivesPreservatives from './SupplierRawMaterialAdditivesPreservatives.vue'
  import SupplierRawMaterialSolvents from './SupplierRawMaterialSolvents.vue'
  import SupplierRawMaterialEnzymesCatalysts from './SupplierRawMaterialEnzymesCatalysts.vue'
  import SupplierRawMaterialGeneticallyModifiedOrganisms from './SupplierRawMaterialGeneticallyModifiedOrganisms.vue'
  import SupplierRawMaterialAllergens from './SupplierRawMaterialAllergens.vue'
  import SupplierRawMaterialBiologicallyActivePrinciples from './SupplierRawMaterialBiologicallyActivePrinciples.vue'
  import SupplierRawMaterialPalmOilDerivatives from './SupplierRawMaterialPalmOilDerivatives.vue'
  import SupplierRawMaterialAdditionalInformation from './SupplierRawMaterialAdditionalInformation.vue'
  import SupplierRawMaterialStorageShelfLife from './SupplierRawMaterialStorageShelfLife.vue'
  import SupplierRawMaterialPackagingTransport from './SupplierRawMaterialPackagingTransport.vue'
  import SupplierRawMaterialDietarySuitability from './SupplierRawMaterialDietarySuitability.vue'
  import SupplierRawMaterialProductTreatments from './SupplierRawMaterialProductTreatments.vue'
  import SupplierRawMaterialLegislativeStatus from './SupplierRawMaterialLegislativeStatus.vue'
  import SupplierRawMaterialGlobalSuitability from './SupplierRawMaterialGlobalSuitability.vue'
  import SupplierRawMaterialSupportingDocumentation from './SupplierRawMaterialSupportingDocumentation.vue'
  import SupplierRawMaterialContaminantsPesticides from './SupplierRawMaterialContaminantsPesticides.vue'
  import SupplierRawMaterialCommercialDetails from './SupplierRawMaterialCommercialDetails.vue'
  import SupplierRawMaterialCompanyData from './SupplierRawMaterialCompanyData.vue'
  import SupplierRawMaterialFgAllocation from './SupplierRawMaterialFgAllocation.vue'



  export default {
    components: {
      'v-select': vSelect,
      SupplierManufacturingHome,
      SupplierManufacturingEmployee,
      SupplierManufacturingSiteDetails,
      SupplierManufacturingQuality,
      SupplierManufacturingEnvironment,
      SupplierManufacturingEthical,
      SupplierManufacturingAllergens,
      SupplierManufacturingHaccp,
      SupplierManufacturingPest,
      SupplierManufacturingTransport,
      SupplierManufacturingHealthSafety,
      SupplierManufacturingAuthenticity,
      SupplierManufacturingHygiene,

      SupplierRawMaterialManufacturingProcess,
      SupplierRawMaterialProductAuthenticity,
      SupplierRawMaterialComposition,
      SupplierRawMaterialAdditivesPreservatives,
      SupplierRawMaterialSolvents,
      SupplierRawMaterialEnzymesCatalysts,
      SupplierRawMaterialGeneticallyModifiedOrganisms,
      SupplierRawMaterialAllergens,
      SupplierRawMaterialBiologicallyActivePrinciples,
      SupplierRawMaterialPalmOilDerivatives,
      SupplierRawMaterialAdditionalInformation,
      SupplierRawMaterialStorageShelfLife,
      SupplierRawMaterialPackagingTransport,
      SupplierRawMaterialDietarySuitability,
      SupplierRawMaterialProductTreatments,
      SupplierRawMaterialLegislativeStatus,
      SupplierRawMaterialGlobalSuitability,
      SupplierRawMaterialSupportingDocumentation,
      SupplierRawMaterialContaminantsPesticides,
      ApproveRawMaterialPopUp,
      SupplierRawMaterialCommercialDetails,
      SupplierRawMaterialCompanyData,
      SupplierRawMaterialFgAllocation
    },
    data () {
      return {
        activeTab: 0,
        id: null,
        status: {},
        index: null,
        isProduction: true,
        rawMaterialDetails: {},
        form: {},
        markCompletedList: {},
        stageOptions:[
          {
            key:true,
            value:'PRODUCTION'
          },
          {
            key:false,
            value:'DEVELOPMENT'
          }
        ]
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
      notify() {
        this.fetchRmDetails()
        this.activeTab++
      },
      async markAsComplete(key) {
        try {
          await SupplierRawMaterialRepository.setMarkAsComplete(this.id, {key: key})
          this.markCompletedList = (await SupplierRawMaterialRepository.getMarkCompleteList(this.id)).data.data
          this.showSuccessMessage('Selected section set as completed')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      isCompleted(key) {
        return this.markCompletedList[key]
      },
      firstPage(event) {
        location.reload();
      },
      addSgValue() {
        this.activeTab = 2
      },
      async checkStepFactory() {
        return Object.entries(this.status).forEach(([key, value], index) => {
          if (value === 0) {
            return index--
          }
        });
      },
      onClickGoBack() {
        this.$router.push({path: `/pages/manage-nimble/suppliers/${this.rawMaterialDetails.supplier.id}`, query: {step: '3'}})
        // this.$router.go(-1)
      },
      statusColorFactory(id) {
        switch (id) {
          case 1:
            return 'danger'
          case 2:
            return 'warning'
          case 3:
            return 'success'
          default:
            return 'danger'
        }
      },
      onClickSuspendLevel(id) {
        this.rmSuspendDialog(id)
      },
      rmSuspendDialog(id){
        this.colorAlert = 'danger'
        this.$vs.dialog({
          color:this.colorAlert,
          title: `Confirm Suspend Level ${id}`,
          text: `Are you sure change this Raw Material status to suspend level ${id}`,
          accept:this.suspendRawMaterial,
          parameters: [id]
        })
      },
      async suspendRawMaterial(params) {
        this.$vs.loading()
        try {
          const data = (await SupplierRawMaterialRepository.suspendRawMaterial(this.id, params[0]))
          this.showSuccessMessage(`Selected raw material change status to suspend Level ${params[0]}`);
          location.reload();
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      openRejectConfirm() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.onClickRejectRawMaterial
        })
      },
      async onClickRejectRawMaterial() {
        this.$vs.loading()
        try {
          const data = (await SupplierRawMaterialRepository.rejectRawMaterial(this.id))
          this.showSuccessMessage(`Selected raw material rejected`);
          location.reload();
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      openApprovalConfirm() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.onClickApproveRawMaterialPopUp
        })
      },
      openApprovalDirectConfirm() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.onClickReInstateRawMaterialPopUp
        })
      },
      openReInstateConfirm() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.onClickReInstateRawMaterialPopUp
        })
      },
      async onClickApproveRawMaterialPopUp() {
        await this.$refs.approveRawMaterialPopUp.openPopup(this.id)
      },
      async onClickApproveRawMaterial() {
        const vue = this;
         try {
           this.$vs.loading();
           await SupplierRawMaterialRepository.approveRawMaterial(this.id)
           this.showSuccessMessage('The selected raw material status changed successfully!');
           location.reload();
         } catch (e) {
           this.convertAndNotifyError(e)
         }
        this.$vs.loading.close();
      },
      async onClickReInstateRawMaterialPopUp() {
        const vue = this;
         try {
           this.$vs.loading();
           await SupplierRawMaterialRepository.reinstateRawMaterial(this.id)
           this.showSuccessMessage('The selected raw material status changed successfully!');
           location.reload();
         } catch (e) {
           this.convertAndNotifyError(e)
         }
        this.$vs.loading.close();
      },
      onChangeStageConfirm() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.onChangeStage,
          cancel: this.cancelChangeStage
        })
      },
      async onChangeStage() {
        this.rawMaterialDetails.raw_material_stage = this.isProduction ? 'production' : 'development'
        this.$vs.loading()
        try {
          this.rawMaterialDetails.manufacturing_site = this.id
          const data = (await SupplierRawMaterialRepository.rawMaterialStageChange(this.id, this.isProduction ? 'production' : 'development'))
          this.showSuccessMessage('Raw Material Stage Updated!')
          location.reload()
        }catch (e) {
          this.convertAndNotifyError(e)
          this.isProduction = !this.isProduction
        }
        this.$vs.loading.close()
      },
      cancelChangeStage() {
        this.isProduction = !this.isProduction
      },
      async fetchRmDetails() {
        const { data } = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
        this.rawMaterialDetails = (await SupplierRawMaterialRepository.getRawMaterialDetails(this.id)).data.data
        this.status = data
        this.markCompletedList = (await SupplierRawMaterialRepository.getMarkCompleteList(this.id)).data.data
        this.isProduction = this.rawMaterialDetails.raw_material_stage !== "development";
      },

    },
    async mounted() {
      this.id = this.$route.params.id
      if(this.$route.query.price_request) {
        this.activeTab = 22
      }
      await this.fetchRmDetails()
      this.activeTab =  this.$route.query.step ? this.$route.query.step : '0'
    },
    computed: {
      isSmallerScreen () {
        return this.$store.state.windowWidth < 768
      }
    }
  }
</script>

<style lang="scss">
  .stageSelect{
    width: 300px;
  }
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
  .dropdown-button-container {
    display: flex;
    align-items: center;

    .btnx {
      border-radius: 5px 0px 0px 5px;
    }

    .btn-drop {
      border-radius: 0px 5px 5px 0px;
      border-left: 1px solid rgba(255, 255, 255, .2);
    }
  }
</style>
